import { Component, Inject, Input, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IBoleto } from 'src/app/interfaces';
import { ModalDownloadBoletoComponent } from '../modal-download-boleto/modal-download-boleto.component';
import { ENVIRONMENT } from 'src/app/constants';
import { Environment } from 'src/app/types';

@Component({
  selector: 'app-item-boleto-mobile',
  templateUrl: './item-boleto-mobile.component.html',
  styleUrls: ['./item-boleto-mobile.component.scss']
})
export class ItemBoletoMobileComponent {
  @ViewChild(ModalDownloadBoletoComponent)
  modalDownloadBoleto!: ModalDownloadBoletoComponent;
  @Input() boleto!: IBoleto;

  isBoletoCollapsed = true;
  constructor(
    private modalService: NgbModal,
    @Inject(ENVIRONMENT) public environment: Environment
  ) {}

  downloadBoleto(boleto: IBoleto) {
    this.modalDownloadBoleto.openModal(boleto);
  }

  closeModal() {
    this.modalService.dismissAll();
  }
}
